import script from "./SegmentToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentToggle.vue?vue&type=script&setup=true&lang=js"

import "./SegmentToggle.vue?vue&type=style&index=0&id=742d68ce&lang=scss"

const __exports__ = script;

export default __exports__